//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  const svgCache = {};

    // This directive is meant for usage with dev-sourced SVGs.
    // As such, right now it only supports single-SVG files from root-relative paths
    // (e.g. /images/my-svg.svg)
    // If you want to use it to support arbitrary URLs for SVGs, you should consider security as you enable those URLs.
  curalate.directive('svgIcon', [
    '$http',
    '$templateCache',
    '$log',
    '$q',
    '$sce',
    '$window',
    function(
            $http,
            $templateCache,
            $log,
            $q,
            $sce,
            $window,
        ) {
      const loadByUrl = function(url) {
        if (svgCache.hasOwnProperty(url)) {
          return $q.resolve(svgCache[url].cloneNode(true));
        }

        return $http
                    .get(url, { cache: $templateCache })
                    .then((response) => {
                      const svg = angular.element('<div>').append(response.data).find('svg')[0];
                      svgCache[url] = svg;
                      return svg.cloneNode(true);
                    }).catch((err) => {
                      const msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
                      $log.warn(msg);

                      return $q.reject(msg);
                    });
      };
      const traverseChildren = function(node, fn) {
        let i;
        for (i = 0; i < node.childNodes.length; i++) {
          traverseChildren(node.childNodes[i], fn);
          fn(node.childNodes[i]);
        }
      };

            // Fix IRIs in SVG element based on current BASE path
      const fixIris = function(svgElement) {
        let currentBase = svgElement.baseURI;
        if (!currentBase) {
                    // IE11 doesn't support .baseURI despite it being DOM3 core.
          currentBase = document.querySelector('base');
          currentBase = currentBase && currentBase.href;
        }

        if (!currentBase || currentBase !== $window.location.href) {
                    // There is currently a base URI active other than the current URL.
                    // We should fix our SVG IRIs.
          const currentHref = $window.location.origin +
                        $window.location.pathname +
                        $window.location.search;


          traverseChildren(svgElement, (el) => {
            if (el.attributes) {
              Array.prototype.slice.call(el.attributes).forEach((attr) => {
                if (attr.name === 'xlink:href' && attr.value[0] === '#') {
                                    // Replace all xlink:href="#..." refrences
                  attr.value = currentHref + attr.value;
                } else {
                                    // Replace all attr="url(#...)" references
                  attr.value = attr.value.replace(/^url\(#/, `url(${currentHref}#`);
                }
              });
            }
          });
        }

        return svgElement;
      };

      return {
        restrict: 'E',
        link(scope, elm, attrs) {
          const src = $sce.getTrustedResourceUrl(attrs.src);

          const svgName = /\/([^./]+)(\.[a-f0-9]+)?\.svg$/.exec(attrs.src)[1]; // Match just the name part of the filename

          elm.addClass(`svg-icon-${svgName}`); // Add a class based on the svg filename.

          loadByUrl(src).then((e) => {
                        // Fix IRI references for pages with <base> tags. Ref: DEV-23771
            if ($.browser.mozilla && $.browser.versionNumber < 55) {
              fixIris(e);
            }
            elm.html(e);


                        // The following comments and lines are adapted from svg-injector, which is under the MIT License.
                        // :WORKAROUND:
                        // IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
                        // This trick will trigger IE to read and use any existing SVG <style> tags.
                        //
                        // Reference: https://github.com/iconic/SVGInjector/issues/23
            Array.prototype.forEach.call(elm[0].querySelectorAll('style'), (styleTag) => {
              styleTag.textContent += '';
            });
          });
        },
      };
    },
  ]);
})();
